// KPI tile — the strip above a grid's toolbar (Invoicing aging, Dispatch week health). Same look everywhere.
export function SummaryTile({ label, value, hint, tone = "slate", active, onClick, testId }) {
  const tones = {
    slate: "border-slate-200 bg-white",
    amber: "border-amber-200 bg-amber-50/60",
    rose: "border-rose-200 bg-rose-50/60",
    emerald: "border-emerald-200 bg-emerald-50/60",
  };
  return (
    <button
      type="button" onClick={onClick} disabled={!onClick}
      className={`text-left rounded-lg border px-3 py-2 transition-all ${tones[tone]}
        ${onClick ? "hover:shadow-sm hover:-translate-y-px cursor-pointer" : "cursor-default"}
        ${active ? "ring-2 ring-brand/70" : ""}`}
      data-testid={testId}
    >
      <div className="text-[11px] text-slate-500">{label}</div>
      <div className="text-lg font-semibold text-slate-900 leading-tight stat-num">{value}</div>
      {hint && <div className="text-[11px] text-slate-500 num">{hint}</div>}
    </button>
  );
}
